import { render, staticRenderFns } from "./FrameWork.vue?vue&type=template&id=44a87d18&scoped=true"
import script from "./FrameWork.vue?vue&type=script&lang=js"
export * from "./FrameWork.vue?vue&type=script&lang=js"
import style0 from "./FrameWork.vue?vue&type=style&index=0&id=44a87d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a87d18",
  null
  
)

export default component.exports